import { NotAuthorizedPage } from './not-authorized.component';

export default NotAuthorizedPage;
